<div class="templates-list">
    <div *ngFor="let template of templates">
        <span class="files-style">
            <div class="template-border">
                <span class="file-name">{{ template.name }}</span>
                <div class="edit">
                    <aumico-button (click)="addOrUpdateTemplate(template._id)">{{
                        'aumico_templates_list_edit' | i18next 
                    }}</aumico-button>
                </div>
            </div>
        </span>
    </div>
    <div class="template-border no-hover">
        <span class="file-name">{{ 'aumico_templates_list_new_template' | i18next  }}</span>
        <div class="edit">
            <aumico-button (click)="addOrUpdateTemplate()">{{
                'aumico_templates_list_new' | i18next 
            }}</aumico-button>
        </div>
    </div>
</div>
